import { h, Component } from 'preact';
import { regex, config, constants } from './../config';
import * as Helper from './../helper';

export default class PlayerLayout extends Component {
  constructor(props) {
    super(props);
    this.interactingEventMaxFired = {};
  }

  componentDidMount() {
    this.getLayout();
    this.mapPostMsgProp = this.mapPostMsgProp();
  }

  render() {
    return this.renderLayout();
  }

  checkCtaPassThrough() {
    let settings = this.props.tag.settings;
    let category = settings.category;
    let subcategory = settings.subcategory && settings.subcategory[0] && settings.subcategory[0].type;

    if (this.props.lsCards) {
      return false;
    }

    switch (category) {
      case 1:
      case 7:
      case 8:
      case 10:
      case 16:
        return false;
      case 12:
        switch (subcategory) {
          case 1200:
          case 1201:
          case 1204:
            return false;
          case 1202:
          case 1203:
            return true;
        }
      case 9:
      case 11:
      case 14:
        if (this.props.ottRect && !this.props.isExpanded) {
          return true;
        } else {
          return false;
        }
    }
  }

  mapPostMsgProp = () => {
    let tag = this.props.tag;
    let subcategory = tag.settings.subcategory;
    let engagement = subcategory && subcategory[0] && subcategory[0].engagements && subcategory[0].engagements[0];

    return (key) => {
      switch (key) {
        case 'cta_link':
          return (engagement && engagement[`value|${engagement.slug}`]) || '';
        case 'cta_text':
          return (engagement && engagement[`label|${engagement.slug}`]) || '';
        case 'video_id':
          return this.props.json.video_id;
      }
    };
  };

  getExternalLinkMessage = (postMsg) => {
    let data = postMsg.data;
    let message = {};

    for (var key in data) {
      message[key] = this.mapPostMsgProp(data[key]);
    }

    return message;
  };

  handleExternalLink = (url) => {
    let json = this.props.json;
    let tag = this.props.tag;
    let postMsg = json.post_msg;
    let isEnabledGlobal = postMsg && postMsg.enablement === 'ALL';
    let isPostMsgEnabled = isEnabledGlobal || tag.post_msg_enabled;
    // let isPostMsgEnabled = true;

    if (!regex.httpCheck.test(url)) url = `http://${url}`;
    if (isPostMsgEnabled && window.parent && window.parent.postMessage) {
      window.parent.postMessage(JSON.stringify(this.getExternalLinkMessage(json.post_msg)), json.post_msg.url || '*');
      // window.parent.postMessage(JSON.stringify(this.getExternalLinkMessage({
      //   "enablement": "ALL",
      //     "url":"https://www.paypal.com",
      //     "data": {
      //       "link": "cta_link",
      //       "content": "cta_text",
      //       "video_id":"video_id",
      //     }
      // })), ('*'));
    } else {
      // let redirect = window.open(url, '_blank');
      // OneAd clickThru---
			Helper.handleExternalLinksViaClickThru(url, this.props.creativeData);
			//---
      this.handleVideoResume();
      // redirect.location;
    }
  };

  handleTagClick = (e, skipLogDataEvent) => {
    let classList = e.target.classList;
    let clickPassThrough = this.checkCtaPassThrough();

    if (
      (!this.props.isLandscape &&
        !classList.contains('swiper-button-next') &&
        !classList.contains('swiper-button-prev') &&
        !this.props.isFacebookAd &&
        !this.props.lsCards) ||
      clickPassThrough
    ) {
      if (this.props.tag && !Helper.isSkipEnabled(this.props.tag, this.props.creativeData) && !this.props.isExpanded) {
        this.props.activateTag(this.props.index, null, true);
      } 
      
      if (!skipLogDataEvent) {
        this.logInteractionEvent(this.props.getCurrentTime(), 'manual');
      }
    }

    if (this.props.displayAdClickThroughLink) {
      // Engagement event for display ad click & traffic---
      if (this.props.displayAdClickThroughLink.length > 0) {
        this.logEngagement({ engagement_type: `out-video`, event_type: 'display-ad' });
      }
      //---
      this.props.displayAdClickThroughLink.forEach((link) => {
        setTimeout(() => {
          window.open(link);
        }, 0);
      });
    }
  };

  handleCardClose = (e) => {
    this.props.renderLandscapeCards(false);
  };

  handleTagClose = (e) => {
    if (e) {
      e.stopPropagation();
    }

    this.props.destroyTag();
    this.props.deactivateTag();
    this.handleCardClose(false);

    this.logTagCloseEvent();
  };

  handleCTA = (e, updatedEngagements) => {
    let engagements = updatedEngagements || this.getEngagements();
    let action = engagements && engagements[0];
    let engagementMode = action.meta;
    let type = action.validationType;
    let actionValue = action[`value|${action.slug}`];

    if (engagementMode === config.engagementTypes.outVideo) {
      this.handleOutVideo(type, actionValue);
      // fire `interacting` as soon as CTA is clicked---
      this.interactingEventMaxOnUserClick();
    }
  };

  handleOutVideo = (type, actionValue) => {
    switch (type) {
      case 'text':
      case 'url':
        return this.handleExternalLink(actionValue);
      case 'email':
        window.location.href = `mailto:${actionValue}`;
        break;
    }
  };

  handleSlideChange = () => {
    let engagements = this.getEngagements();
    let action = engagements && engagements[0];
    let actionLabel = action[`label|${action.slug}`];
    let actionValueFormtted = action.slug;

    let tag_id = this.props.tag.id;
    let tag_label =
      this.props.tag &&
      this.props.tag.details &&
      (this.props.tag.details.preview_title || this.props.tag.details.title);
    let engagement_id = action && action.id;
    let engagement_label = actionLabel;

    let logDataObj = {
      type: actionValueFormtted,
      sub_type: null,
      event_type: actionValueFormtted,
      tag_id,
      tag_label,
      engagement_id,
      engagement_label,
      current_duration: this.props.getCurrentTime(),
    };

    this.props.eventBus(constants.LOG_EVENT_GALLERY_INTERACTION, {
      tag: this.props.tag,
      ...logDataObj,
      duration: this.props.getCurrentTime(),
    });
    // this.props.logDataEvent(logDataObj);
  };

  checkEnforcedOrExpandedTag = () => {
    const custom = this.props.json && this.props.json.custom;
    const customEnforeEndCardEnabled = custom && custom.endcards && custom.endcards.enforceEndCard;
    const customEnforeEndCardTagId = custom && custom.endcards && custom.endcards.enforceEndCardTag;

    const showEndCardPreviewEnabled = custom && custom.endcards && custom.endcards.showEndCardPreview;
    const showEndCardPreviewTagId = custom && custom.endcards && custom.endcards.showEndCardTag;

    const tagId = this.props.tag.id;
    const hasVideoEnded = this.props.hasVideoEnded();
    return hasVideoEnded && ((customEnforeEndCardEnabled && tagId === customEnforeEndCardTagId) || (showEndCardPreviewEnabled && tagId === showEndCardPreviewTagId));
  }

  logEngagement = (data) => {
    let engagements = this.getEngagements();
    let action = engagements && engagements[0];
    let actionValueFormtted = action.slug;

    let tag_id = this.props.tag.id;
    let tag_label =
      this.props.tag &&
      this.props.tag.details &&
      (this.props.tag.details.preview_title || this.props.tag.details.title);
    let engagement_id = action && action.id;
    let engagement_label = (data && data.engagement_label) || action[`label|${action.slug}`];

    let tag = this.props.tag;
    let category = tag.settings.category;
    let engagement_type = '';
    switch (category) {
      case 1:
      case 7:
      case 8:
      case 10:
      case 16:
        engagement_type = 'out-video';
        break;

      case 9:
      case 11:
      case 12:
      case 14:
      case 15:
        engagement_type = 'in-video';
        break;
    }
    engagement_type = (data && data.engagement_type) || engagement_type;
    const event_type = (data && data.event_type) || actionValueFormtted;

    let requestData = {
      type: actionValueFormtted,
      sub_type: null,
      event_type,
      tag_id,
      tag_label,
      engagement_id,
      engagement_label,
      current_duration: this.props.getCurrentTime(),
      engagement_type,
      tag_type: actionValueFormtted
    };

    if (typeof data !== 'undefined') {
      requestData = Object.assign(requestData, data);
    }

    if (typeof data !== 'undefined' && data.event_type && data.event_type === 'decision') {
      requestData.engagement_label = tag_label;
    }

    this.props.eventBus(constants.LOG_EVENT_ENGAGEMENT, {
      options: requestData
    });

    if(this.checkEnforcedOrExpandedTag()) {
      this.props.eventBus(constants.LOG_EVENT_INTERACTION, {
        tag: this.props.tag,
        current_duration: this.props.getCurrentTime(),
      });
    }

    // this.props.logDataEvent(requestData);
  };

  logTagOpenEvent = (overrideDirectTag) => {
    if (this.props.hasDirectTag && !overrideDirectTag) {
      return false;
    }

    this.openTs = new Date().getTime();
    this.props.eventBus(constants.LOG_EVENT_TAG_OPEN, {
      tag: this.props.tag,
      duration: this.props.getCurrentTime(),
    });
    
    /**
     * `interacting` event to be fired after 30sec if tag stays open---
     */
    clearInterval(this.interactingTimeout);
    const interactingDelay = constants.INTERACTING_EVENT_DELAY / 1000;
    this.interactingTimeout = setTimeout(() => {
      this.fireInteractingEvent(interactingDelay);
    }, constants.INTERACTING_EVENT_DELAY);

    this.interactingEventMaxFired[this.props.tag.id] = false;
    // max duration for `interacting`---
    const manualMaxTime = this.props.tag && this.props.tag.details && this.props.tag.details.interactingMaxTime;
    const maxInteractingTimeout = manualMaxTime || (this.props.json.duration <= 7 ? this.props.json.duration : 7);
    this.interactingTimeoutMax = setTimeout(() => {
      clearInterval(this.interactingTimeout);
      if (!this.interactingEventMaxFired[this.props.tag.id]) {
        this.fireInteractingEvent(maxInteractingTimeout - interactingDelay);
        this.interactingEventMaxFired[this.props.tag.id] = true;
      }
    }, maxInteractingTimeout * 1000);
  };

  logTagCloseEvent = () => {
    /**
     * Tag interaction time is now calculated by the `interacting` event duration sum in the backend,
     * so if tag open 3sec `interacting` event is already fired, tag close `interactin event duration` will be the remaining time from 30sec to the close event.
     * else it will be time from tag open.
     */
    this.interactingEventMaxOnUserClick();

    const closeDuration = this.openTs ? Math.round((new Date().getTime() - this.openTs) / 1000) : 10;
    this.props.setTagAutoInteraction(false);
    this.props.eventBus(constants.LOG_EVENT_TAG_CLOSE, {
      tag: this.props.tag,
      duration: closeDuration,
      current_duration: this.props.getCurrentTime(),
    });
  };

  interactingEventMaxOnUserClick = () => {
    const closeDuration = this.openTs ? Math.round((new Date().getTime() - this.openTs) / 1000) : 10;
    clearInterval(this.interactingTimeout);
    clearTimeout(this.interactingTimeoutMax);
    if (!this.interactingEventMaxFired[this.props.tag.id]) {
      this.interactingEventMaxFired[this.props.tag.id] = true;
      const interactingDelay = constants.INTERACTING_EVENT_DELAY / 1000;
      const duration = closeDuration >= interactingDelay ? closeDuration - interactingDelay : closeDuration;
      if (duration > 0) {
        this.fireInteractingEvent(duration);
      }
    }
  }

  fireInteractingEvent = (duration) => {    
    this.props.eventBus(constants.LOG_EVENT_INTERACTING, {
      tag: this.props.tag,
      duration,
      current_duration: this.props.getCurrentTime(),
    });
  }

  logInteractionEvent = (current_duration, click_type) => {
    // let evt = click_type === 'auto' ? constants.LOG_EVENT_CLICK_AUTO : constants.LOG_EVENT_CLICK_MANUAL;
    this.props.eventBus(constants.LOG_EVENT_INTERACTION, {
      tag: this.props.tag,
      current_duration,
    });
  };

  getEngagements = () => {
    return Helper.getEngagements(this.props.tag);
  };

  getImageCount = () => {
    let hook = this.props.tag.media && this.props.tag.media.images;
    let i = 1;
    let count = 0;

    while (hook && hook[`img${i}_src`]) {
      count = i;
      i++;
    }

    return count;
  };

  getLayout() {
    let settings = this.props.tag.settings;
    let category = settings.category;
    let subcategory = settings.subcategory && settings.subcategory[0] && settings.subcategory[0].type;

    switch (category) {
      case 1:
        switch (subcategory) {
          case 105:
            return this.fetchLayout('TmplCommerceCollections', 'commerceCollections');
          case 106:
            return this.fetchLayout('TmplCommerceProduct360', 'commerceProduct360');
          case 104:
            return this.fetchLayout('TmplCommerceMultiStores', 'commerceMultiStores');
          case 107:
            return null; // Collections Video doesn't have any details
          default:
            return this.fetchLayout('TmplCommerce', 'commerce');
        }
      case 7:
        return this.fetchLayout('TmplCommerce', 'commerce');
      case 8:
        return this.fetchLayout('TmplBooking', 'booking');
      case 9:
        switch (subcategory) {
          case 900:
            return this.fetchLayout('TmplParticipationPoll', 'participationPoll');
          case 901:
            return this.fetchLayout('TmplParticipationSignUp', 'participationSignUp');
          case 902:
            return this.fetchLayout('TmplParticipationLeadGen', 'participationLeadGen');
          case 904:
            return this.fetchLayout('TmplParticipationCounter', 'participationCounter');
          case 905:
            return this.fetchLayout('TmplParticipationFeedback', 'participationFeedback');
          case 906:
            return this.fetchLayout('TmplParticipationContest', 'participationContest');
          case 907:
            return this.fetchLayout('TmplParticipationCall', 'participationCall');
        }
      case 10:
        switch (subcategory) {
          case 1000:
            return this.fetchLayout('TmplGamesAndAppsDriveInstalls', 'gamesAndAppsDriveInstalls');
          case 1001:
            return this.fetchLayout('TmplGamesAndAppsDriveUsage', 'gamesAndAppsDriveUsage');
        }
      case 11:
        return this.fetchLayout('TmplStoreLocator', 'storeLocator');
      case 12:
        switch (subcategory) {
          case 1200:
          case 1201:
            return this.fetchLayout('TmplOffersOfferOnAndOffline', 'offersOfferOnAndOffline');
          case 1202:
            return this.fetchLayout('TmplOffersSingleCode', 'offersSingleCode');
          case 1203:
            return this.fetchLayout('TmplOffersMultipleCode', 'offersMultipleCode');
          case 1204:
            return this.fetchLayout('TmplOffersBanner', 'offersBanner');
        }
      case 14:
        switch (subcategory) {
          case 1401:
            return this.fetchLayout('TmplShowcaseGallery', 'showcaseGallery');
          case 1402:
            return this.fetchLayout('TmplShowcaseChapter', 'showcaseChapter');
          case 1403:
            return this.fetchLayout('TmplShowcaseMultiHotspot', 'showcaseMultiHotspot');
        }
      case 15:
        switch (subcategory) {
          case 1501:
          case 1502:
            let tag = this.props.tag;
            let engagement = tag.details.engagements && tag.details.engagements[0];

            if (engagement && engagement.dpnative) {
              return this.fetchLayout('TmplDecisionsV2', 'decisionsV2');
            } else {
              return this.fetchLayout('TmplDecisions', 'decisions');
            }
        }
      case 16:
        switch (subcategory) {
          case 1601:
            return this.fetchLayout('TmplSocialShare', 'socialShare');
          case 1602:
            return this.fetchLayout('TmplSocialEmotion', 'socialEmotion');
        }
      case 17:
        switch (subcategory) {
          case 1700:
            return this.fetchLayout('TmplEventsCalendar', 'eventsCalendar');
          case 1701:
            return this.fetchLayout('TmplEventsWebinar', 'eventsWebinar');
        }
      case 18:
        switch (subcategory) {
          case 1801:
            return this.fetchLayout('TmplCommerce', 'commerce');;
          case 1802:
            return this.fetchLayout('TmplCommerceCollections', 'commerceCollections');
          case 1803:
            return this.fetchLayout('TmplParticipationCounter', 'participationCounter');
        }
      case 19:
        switch (subcategory) {
          case 1901:
            return this.fetchLayout('TmplParticipationSignUp', 'participationSignUp');
          case 1902:
          case 1903:
            return this.fetchLayout('TmplParticipationLeadGen', 'participationLeadGen');
        }
      case 20:
        switch (subcategory) {
          case 2001:
            return this.fetchLayout('TmplParticipationLeadGen', 'participationLeadGen');
          case 2002:
            return this.fetchLayout('TmplParticipationCall', 'participationCall');
          case 2003:
            return this.fetchLayout('TmplParticipationBookDemo', 'participationBookDemo');
        }
      case 21:
        switch (subcategory) {
          case 2101:
            return this.fetchLayout('TmplParticipationContest', 'participationContest');
          case 2102:
            return this.fetchLayout('TmplParticipationFeedback', 'participationFeedback');
          case 2103:
            return null;
          case 2104:
            return this.fetchLayout('TmplParticipationPoll', 'participationPoll');
        }
    }
  }

  renderLayout() {
    let settings = this.props.tag.settings;
    let category = settings.category;
    let subcategory = settings.subcategory && settings.subcategory[0] && settings.subcategory[0].type;

    switch (category) {
      case 1:
        switch (subcategory) {
          case 105:
            return this.renderTmpl('TmplCommerceCollections');
          case 106:
            return this.renderTmpl('TmplCommerceProduct360');
          case 104:
            return this.renderTmpl('TmplCommerceMultiStores');
          default:
            return this.renderTmpl('TmplCommerce');
        }
      case 7:
        return this.renderTmpl('TmplCommerce');
      case 8:
        return this.renderTmpl('TmplBooking');
      case 9:
        switch (subcategory) {
          case 900:
            return this.renderTmpl('TmplParticipationPoll');
          case 901:
            return this.renderTmpl('TmplParticipationSignUp');
          case 902:
            return this.renderTmpl('TmplParticipationLeadGen');
          case 904:
            return this.renderTmpl('TmplParticipationCounter');
          case 905:
            return this.renderTmpl('TmplParticipationFeedback');
          case 906:
            return this.renderTmpl('TmplParticipationContest');
          case 907:
            return this.renderTmpl('TmplParticipationCall');
        }
      case 10:
        switch (subcategory) {
          case 1000:
            return this.renderTmpl('TmplGamesAndAppsDriveInstalls');
          case 1001:
            return this.renderTmpl('TmplGamesAndAppsDriveUsage');
        }
      case 11:
        return this.renderTmpl('TmplStoreLocator');
      case 12:
        switch (subcategory) {
          case 1200:
          case 1201:
            return this.renderTmpl('TmplOffersOfferOnAndOffline');
          case 1202:
            return this.renderTmpl('TmplOffersSingleCode');
          case 1203:
            return this.renderTmpl('TmplOffersMultipleCode');
          case 1204:
            return this.renderTmpl('TmplOffersBanner');
        }
      case 14:
        switch (subcategory) {
          case 1401:
            return this.renderTmpl('TmplShowcaseGallery');
          case 1402:
            return this.renderTmpl('TmplShowcaseChapter');
          case 1403:
            return this.renderTmpl('TmplShowcaseMultiHotspot');
        }
      case 15:
        switch (subcategory) {
          case 1501:
          case 1402:
            return this.renderTmpl('TmplDecisions');
          case 1502:
            let tag = this.props.tag;
            let engagement = tag.details.engagements && tag.details.engagements[0];

            if (engagement && engagement.dpnative) {
              return this.renderTmpl('TmplDecisionsV2');
            } else {
              return this.renderTmpl('TmplDecisions');
            }
        }
      case 16:
        switch (subcategory) {
          case 1601:
            return this.renderTmpl('TmplSocialShare');
          case 1602:
            return this.renderTmpl('TmplSocialEmotion');
        }
      case 17:
        switch (subcategory) {
          case 1700:
            return this.renderTmpl('TmplEventsCalendar');
          case 1701:
            return this.renderTmpl('TmplEventsWebinar');
        }
      case 18:
        switch (subcategory) {
          case 1801:
            return this.renderTmpl('TmplCommerce');
          case 1802:
            return this.renderTmpl('TmplCommerceCollections');
          case 1803:
            return this.renderTmpl('TmplParticipationCounter');
        }
      case 19:
        switch (subcategory) {
          case 1901:
            return this.renderTmpl('TmplParticipationSignUp');
          case 1902:
          case 1903:
            return this.renderTmpl('TmplParticipationLeadGen');
        }
      case 20:
        switch (subcategory) {
          case 2001:
            return this.renderTmpl('TmplParticipationLeadGen');
          case 2002:
            return this.renderTmpl('TmplParticipationCall');
          case 2003:
            return this.renderTmpl('TmplParticipationBookDemo');
        }
      case 21:
        switch (subcategory) {
          case 2101:
            return this.renderTmpl('TmplParticipationContest');
          case 2102:
            return this.renderTmpl('TmplParticipationFeedback');
          case 2103:
            return null;
          case 2104:
            return this.renderTmpl('TmplParticipationPoll');
        }
    }
  }

  fetchLayout = (ns, tmpl) => {
    if (!this[ns]) {
      import(
        /* webpackChunkName: "chunk-[request]" */
        `./../spareparts/templates/${tmpl}`
      ).then((res) => {
        this[ns] = res;
        this.forceUpdate();
      });
    }
  };

  handleVideoResume = () => {
    const meta = this.props.json.meta;
    const videoResume = meta && meta.video_resume || {};
    const tagid = this.props.tag.id;
    if (videoResume[tagid]) {
      this.handleTagClose();
      // for linked tags---
      if (this.props.handleTagClose && typeof this.props.handleTagClose === 'function') {
        this.props.handleTagClose();
      }
    }
  }

  renderTmpl(ns) {
    if (this[ns] && this[ns].default) {
      const Component = this[ns].default;
      return (
        <Component
          {...this.props}
          getEngagements={this.getEngagements}
          getImageCount={this.getImageCount}
          logEngagement={this.logEngagement}
          logTagOpenEvent={this.logTagOpenEvent}
          logTagCloseEvent={this.logTagCloseEvent}
          logInteractionEvent={this.logInteractionEvent}
          handleCTA={this.handleCTA}
          handleTagClick={this.handleTagClick}
          handleTagClose={this.handleTagClose}
          handleSlideChange={this.handleSlideChange}
          handleExternalLink={this.handleExternalLink}
          checkEnforcedOrExpandedTag={this.checkEnforcedOrExpandedTag}
          videoResumeOnCta={this.handleVideoResume}
        />
      );
    } else {
      this.getLayout();
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./components/playerLayout/index.js